import React from "react";

export function SliderQ({ q, value, onChange }) {
  const v = value == null ? Math.round((q.min + q.max) / 2) : Number(value);
  return (
    <div className="st-panel-2 p-6">
      <p className="text-center text-5xl font-extrabold tracking-tight mb-6" style={{ color: value == null ? "var(--st-faint)" : "var(--st-lime)" }} data-testid={`q-${q.id}-value`}>{v}{q.unit}</p>
      <input type="range" min={q.min} max={q.max} step={q.step || 1} value={v} onChange={(e) => onChange(Number(e.target.value))} className="st-range" data-testid={`q-${q.id}-slider`} />
      <div className="flex justify-between st-faint text-xs mt-3"><span>{q.left_label}</span><span>{q.right_label}</span></div>
      {value == null && <p className="text-center st-faint text-xs mt-4">Move the slider to record an answer</p>}
    </div>
  );
}

export function SlidersQ({ q, value, onChange }) {
  const v = value || {};
  return (
    <div className="space-y-3">
      {q.items.map((i) => {
        const set = v[i.id] != null;
        const n = set ? Number(v[i.id]) : Math.round((q.min + q.max) / 2);
        return (
          <div key={i.id} className="st-panel-2 p-4" data-testid={`q-${q.id}-slider-${i.id}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="font-semibold text-[15px]">{i.label}</span>
              <span className="font-extrabold text-lg" style={{ color: set ? "var(--st-lime)" : "var(--st-faint)" }}>{set ? `${n}${q.unit}` : "—"}</span>
            </div>
            <input type="range" min={q.min} max={q.max} step={q.step || 1} value={n} onChange={(e) => onChange({ ...v, [i.id]: Number(e.target.value) })} className="st-range" />
          </div>
        );
      })}
      <p className="st-faint text-xs">Each slider must be set to complete this question.</p>
    </div>
  );
}

export function TextQ({ q, value, onChange }) {
  const v = value || "";
  return (
    <div>
      <textarea value={v} onChange={(e) => onChange(e.target.value.slice(0, q.max_len || 500))} placeholder={q.placeholder} className="st-textarea !min-h-[140px] text-[15px]" data-testid={`q-${q.id}-text`} />
      <p className="st-faint text-xs mt-1 text-right">{v.length} / {q.max_len || 500}</p>
    </div>
  );
}
